export const translations = {
  sv: {
    header: {
      login: 'Kom igång',
      languageLabel: 'Språk',
    },
    nav: {
      training: 'Pass',
      nutrition: 'Kost',
      recipes: 'Recept',
      shop: 'Handla',
    },
    media: {
      hero: 'Hantlar på rad i ett gym',
      gym: 'Gymgolv med hantlar',
      lift: 'Kvinna som tränar med hantlar',
      hiit: 'Högintensiv gruppträning',
      yoga: 'Rörlighet och yoga',
      bowl: 'Färgglad matskål',
      chicken: 'Grillad kyckling med grönsaker',
      meal: 'Matprep med färska råvaror',
      market: 'Färska grönsaker i butik',
      run: 'Löpning utomhus',
      fresh: 'Färska råvaror och mat',
    },
    hero: {
      badge: 'Coach, mat och pass i samma vy',
      line1: 'HÅLL',
      line2: 'RUTINEN.',
      line3: 'BYGG FORMEN.',
      sub: 'FitGainers lägger dagens pass, maten och inköpen i en plan som följer din vecka. Coachen svarar när du frågar, recepten utgår från det som redan finns hemma, och listan visar var veckans mat kostar minst.',
      cta: 'Starta din plan',
      ctaSecondary: 'Så är det uppbyggt',
      stats: [
        { value: '24/7', label: 'Coach som svarar' },
        { value: '1000+', label: 'Recept att laga' },
        { value: '500+', label: 'Pass på film' },
      ],
      chat: [
        { from: 'user', text: 'Jag har bara kyckling, ris och spenat. Vad blir middag?' },
        { from: 'ai', text: 'En skål på 20 minuter, cirka 480 kcal och 38 g protein. Ska jag lägga det som saknas på inköpslistan?' },
        { from: 'user', text: 'Ja, gör det.' },
      ],
      recipeCard: {
        tag: 'Recept från coachen',
        title: 'Kycklingbowl med spenat',
        kcal: '480 kcal',
        protein: '38 g protein',
        time: '20 min',
      },
      floating: [
        { title: 'Dagens energi', value: '1 620 / 2 100 kcal' },
        { title: 'Passet är klart', value: 'Styrka, 35 min' },
      ],
    },
    ticker: [
      'Pass som följer ditt mål',
      'Matplan för veckan',
      'Kalorier och makron',
      'Recept från skafferiet',
      'Coach på ditt språk',
      'Film på varje övning',
    ],
    problems: {
      kicker: 'Var det brukar stanna',
      title: 'Planen håller till onsdag. Sedan tar veckan över.',
      sub: 'De flesta vet redan vad som fungerar. Det som saknas är ett ställe där pass, mat och handling hänger ihop.',
      items: [
        {
          title: 'Appar som inte pratar',
          desc: 'Ett program för passen, ett annat för maten och ett tredje för inköpen. Ingen av dem ser helheten.',
        },
        {
          title: 'Coaching som kostar för mycket',
          desc: 'En tränare och en kostrådgivare gör skillnad, men priset gör att de flesta aldrig börjar.',
        },
        {
          title: 'Rutinen som rinner ut',
          desc: 'Utan en påminnelse som hör till just din dag blir det lätt ett uppehåll, och sedan ett till.',
        },
        {
          title: 'Planering som tar kvällen',
          desc: 'Att räkna, välja övningar och skriva en lista tar ofta längre tid än själva matlagningen.',
        },
      ],
    },
    platform: {
      kicker: 'Ett ställe',
      title: 'Pass, tallrik och inköp i samma plan',
      sub: 'FitGainers samlar coachning, mat och uppföljning så att nästa steg redan ligger klart när du öppnar appen.',
      coachTitle: 'En coach som svarar i chatten',
      coachDesc: 'Fråga om passet, middagen eller veckans vikt. Coachen föreslår ett pass, skriver ett recept och loggar kalorierna medan ni pratar.',
      coachPill: 'Svar på under två sekunder',
      items: [
        {
          title: 'Recept från det du har',
          desc: 'Skriv vad som finns i kylen, eller fota tallriken, och få ett recept som passar målet.',
        },
        {
          title: 'Film som följer din nivå',
          desc: 'Varje övning visas i ett tempo du kan hänga med i, från första veckan.',
        },
        {
          title: 'Prata som vanligt',
          desc: 'Coachen svarar på svenska eller engelska, utan menyer att leta i.',
        },
        {
          title: 'Övningar efter utrustning',
          desc: 'Filtrera på muskelgrupp, hemma eller gym, och hur tungt det ska kännas.',
        },
        {
          title: 'Pass att sätta på direkt',
          desc: 'Styrka, HIIT, yoga och rörlighet, redo när du har tjugo minuter.',
        },
        {
          title: 'Receptbibliotek med filter',
          desc: 'Sortera på kalorier, kost, allergener och det du vill undvika.',
        },
      ],
    },
    nutrition: {
      kicker: 'Kostkoll',
      title: 'Siffrorna blir ett val till middagen',
      sub: 'FitGainers visar var du ligger i dag, så att nästa mål är tydligt innan du öppnar kylen.',
      features: [
        'Kalorier för dagen',
        'Protein, kolhydrater och fett',
        'Måltider du loggar själv',
        'Receptet hamnar i loggen',
        'Uppskattning från en bild',
      ],
      calculatorTitle: 'Mål som utgår från dig',
      calculatorSub: 'Rekommendationen räknas på:',
      calculatorInputs: ['Ålder', 'Kön', 'Vikt', 'Längd', 'Hur aktiv du är', 'Vad du vill åt'],
      macros: [
        { label: 'Protein', pct: 35 },
        { label: 'Kolhydrater', pct: 40 },
        { label: 'Fett', pct: 25 },
      ],
      dailyGoal: 'Dagens mål',
    },
    recipes: {
      kicker: 'Mat som passar',
      title: 'Middagen bestäms innan du blir hungrig',
      sub: 'FitGainers föreslår rätter som ryms i både målet och det du redan har hemma.',
      libraryTitle: 'I receptbiblioteket',
      library: [
        'Filter för kalorier och tillagningstid',
        'Stöd för hur du vill äta',
        'Allergener syns innan du väljer',
        'Portioner som går att laga i förväg',
      ],
      outputTitle: 'Varje recept visar',
      output: [
        'Kalorier',
        'Protein, kolhydrater och fett',
        'Portionsstorlek',
        'Allergener',
        'Tid vid spisen',
        'Hela ingredienslistan',
      ],
    },
    grocery: {
      kicker: 'Handla billigare',
      title: 'Listan vet vilken butik som vinner',
      sub: 'Ingredienserna från veckans mat jämförs mellan butiker, så att totalsumman syns innan du går hemifrån.',
      steps: [
        'Listan skapas från recepten och matplanen du valt.',
        'Priserna jämförs hos butikerna som är med.',
        'Du ser vilken butik som ger lägst total för hela listan.',
        'Summan per butik syns innan du handlar.',
        'Du kan hålla både målet och budgeten.',
        'Matplan, näring och pris ligger i samma flöde.',
      ],
    },
    vision: {
      kicker: 'Vart vi är på väg',
      title: 'Coachning som fler har råd med',
      statement: 'Att ge varje person en plan för träning och mat, utan att det kräver en privat tränare.',
      cards: [
        {
          title: 'Till fler, inte bara några',
          desc: 'Samma typ av stöd som tidigare krävde tid och pengar, öppet för den som vill börja.',
        },
        {
          title: 'En coach för Europa',
          desc: 'Vi bygger en följeslagare för hälsa som svarar på de språk människor faktiskt pratar.',
        },
        {
          title: 'Pengarna går till produkten',
          desc: 'Investeringarna används till passen, matverktygen och infrastrukturen bakom coachen.',
        },
      ],
    },
    cta: {
      title: 'Veckan kan börja med en plan',
      sub: 'Öppna FitGainers och låt nästa pass, nästa middag och nästa inköpslista ligga klara.',
      button: 'Starta med FitGainers',
      note: 'Ingen bindningstid. Avsluta när du vill.',
    },
    footer: {
      blurb: 'FitGainers är en tjänst för träning, kost, recept och coachning. Prenumerationen kostar 200 kronor per månad och debiteras via mobilräkningen eller dras från ditt förbetalda saldo. Den förnyas varje månad tills du säger upp den. Avsluta genom att skicka STOPP FIT till 72300. Du får alltid en gratis bekräftelse. Åldersgräns 18 år. Frågor: help@niffomobile.com.',
      links: [
        { label: 'Regler och villkor', href: '/regler-och-villkor.html' },
        { label: 'Integritetspolicy', href: '/integritetspolicy.html' },
        { label: 'Kontakt', href: 'mailto:help@niffomobile.com' },
      ],
      contactTitle: 'Kontakt',
      company: 'Niffo Mobile B.V.',
      address: 'Stationsplein 28, 1382 AD Weesp, Nederländerna',
      email: 'help@niffomobile.com',
      copyright: 'Copyright © 2026 FitGainers. Alla rättigheter förbehållna.',
    },
  },

  en: {
    header: {
      login: 'Get started',
      languageLabel: 'Language',
    },
    nav: {
      training: 'Sessions',
      nutrition: 'Food',
      recipes: 'Recipes',
      shop: 'Shop',
    },
    media: {
      hero: 'Rows of dumbbells in a gym',
      gym: 'Gym floor with dumbbells',
      lift: 'Woman training with dumbbells',
      hiit: 'High-intensity group training',
      yoga: 'Mobility and yoga',
      bowl: 'Colourful food bowl',
      chicken: 'Grilled chicken with vegetables',
      meal: 'Meal prep with fresh ingredients',
      market: 'Fresh vegetables in a shop',
      run: 'Running outdoors',
      fresh: 'Fresh ingredients and food',
    },
    hero: {
      badge: 'Coach, meals and sessions in one view',
      line1: 'KEEP',
      line2: 'THE HABIT.',
      line3: 'BUILD THE FORM.',
      sub: 'FitGainers puts today’s session, the food and the shopping into one plan that follows your week. The coach answers when you ask, recipes start from what is already at home, and the list shows where the week’s food costs least.',
      cta: 'Start your plan',
      ctaSecondary: 'How it is built',
      stats: [
        { value: '24/7', label: 'Coach on call' },
        { value: '1000+', label: 'Recipes to cook' },
        { value: '500+', label: 'Sessions on video' },
      ],
      chat: [
        { from: 'user', text: 'I only have chicken, rice and spinach. What is dinner?' },
        { from: 'ai', text: 'A bowl in 20 minutes, about 480 kcal and 38 g of protein. Should I add anything missing to the shopping list?' },
        { from: 'user', text: 'Yes, do that.' },
      ],
      recipeCard: {
        tag: 'Recipe from the coach',
        title: 'Chicken bowl with spinach',
        kcal: '480 kcal',
        protein: '38 g protein',
        time: '20 min',
      },
      floating: [
        { title: 'Today’s energy', value: '1,620 / 2,100 kcal' },
        { title: 'Session is ready', value: 'Strength, 35 min' },
      ],
    },
    ticker: [
      'Sessions that follow your goal',
      'A meal plan for the week',
      'Calories and macros',
      'Recipes from the cupboard',
      'A coach in your language',
      'Video for every exercise',
    ],
    problems: {
      kicker: 'Where it usually stops',
      title: 'The plan lasts until Wednesday. Then the week takes over.',
      sub: 'Most people already know what works. What is missing is one place where sessions, food and shopping belong together.',
      items: [
        {
          title: 'Apps that never meet',
          desc: 'One program for sessions, another for food and a third for the shop. None of them sees the whole week.',
        },
        {
          title: 'Coaching that costs too much',
          desc: 'A trainer and a nutrition adviser help, but the price keeps most people from starting.',
        },
        {
          title: 'A habit that fades',
          desc: 'Without a nudge that belongs to your actual day, one pause turns into the next.',
        },
        {
          title: 'Planning that eats the evening',
          desc: 'Counting, choosing exercises and writing a list often takes longer than cooking.',
        },
      ],
    },
    platform: {
      kicker: 'One place',
      title: 'Session, plate and shopping in the same plan',
      sub: 'FitGainers brings coaching, food and follow-up together, so the next step is already waiting when you open the app.',
      coachTitle: 'A coach that answers in the chat',
      coachDesc: 'Ask about the session, dinner or the week’s weight. The coach suggests a workout, writes a recipe and logs the calories while you talk.',
      coachPill: 'A reply in under two seconds',
      items: [
        {
          title: 'Recipes from what you have',
          desc: 'Type what is in the fridge, or photograph the plate, and get a recipe that fits the goal.',
        },
        {
          title: 'Video that matches your level',
          desc: 'Every exercise is shown at a pace you can follow, from the first week.',
        },
        {
          title: 'Talk the way you normally do',
          desc: 'The coach answers in Swedish or English, without menus to hunt through.',
        },
        {
          title: 'Exercises by equipment',
          desc: 'Filter by muscle group, home or gym, and how heavy it should feel.',
        },
        {
          title: 'Sessions you can start now',
          desc: 'Strength, HIIT, yoga and mobility, ready when you have twenty minutes.',
        },
        {
          title: 'A recipe library with filters',
          desc: 'Sort by calories, diet, allergens and what you want to skip.',
        },
      ],
    },
    nutrition: {
      kicker: 'Food tracking',
      title: 'The numbers become a choice for dinner',
      sub: 'FitGainers shows where you stand today, so the next meal is clear before you open the fridge.',
      features: [
        'Calories for the day',
        'Protein, carbohydrates and fat',
        'Meals you log yourself',
        'The recipe lands in the log',
        'An estimate from a photo',
      ],
      calculatorTitle: 'A target that starts from you',
      calculatorSub: 'The recommendation is based on:',
      calculatorInputs: ['Age', 'Sex', 'Weight', 'Height', 'How active you are', 'What you are aiming for'],
      macros: [
        { label: 'Protein', pct: 35 },
        { label: 'Carbs', pct: 40 },
        { label: 'Fat', pct: 25 },
      ],
      dailyGoal: 'Today’s target',
    },
    recipes: {
      kicker: 'Food that fits',
      title: 'Dinner is decided before you get hungry',
      sub: 'FitGainers suggests dishes that fit both the target and what you already have at home.',
      libraryTitle: 'In the recipe library',
      library: [
        'Filters for calories and cooking time',
        'Support for how you want to eat',
        'Allergens are visible before you choose',
        'Portions you can cook ahead',
      ],
      outputTitle: 'Every recipe shows',
      output: [
        'Calories',
        'Protein, carbohydrates and fat',
        'Serving size',
        'Allergens',
        'Time at the stove',
        'The full ingredient list',
      ],
    },
    grocery: {
      kicker: 'Shop for less',
      title: 'The list knows which shop wins',
      sub: 'Ingredients from the week’s meals are compared across shops, so the total is visible before you leave home.',
      steps: [
        'The list is built from the recipes and meal plan you chose.',
        'Prices are compared at the shops that take part.',
        'You see which shop gives the lowest total for the whole list.',
        'The sum per shop is visible before you shop.',
        'You can hold both the target and the budget.',
        'Meal plan, nutrition and price sit in the same flow.',
      ],
    },
    vision: {
      kicker: 'Where this is going',
      title: 'Coaching more people can afford',
      statement: 'To give each person a plan for training and food, without requiring a private trainer.',
      cards: [
        {
          title: 'For more people, not a few',
          desc: 'The kind of support that used to take time and money, open to anyone who wants to start.',
        },
        {
          title: 'A coach for Europe',
          desc: 'We are building a health companion that answers in the languages people actually speak.',
        },
        {
          title: 'The money goes into the product',
          desc: 'Investment is used for the sessions, the food tools and the infrastructure behind the coach.',
        },
      ],
    },
    cta: {
      title: 'The week can start with a plan',
      sub: 'Open FitGainers and let the next session, the next dinner and the next shopping list sit ready.',
      button: 'Start with FitGainers',
      note: 'No lock-in. Cancel when you want.',
    },
    footer: {
      blurb: 'FitGainers is a service for training, food, recipes and coaching. The subscription costs 200 Swedish kronor per month and is charged to your mobile bill or taken from your prepaid balance. It renews each month until you cancel. Cancel by sending STOPP FIT to 72300. You always receive a free confirmation. Age limit 18. Questions: help@niffomobile.com.',
      links: [
        { label: 'Terms and conditions', href: '/regler-och-villkor.html' },
        { label: 'Privacy policy', href: '/integritetspolicy.html' },
        { label: 'Contact', href: 'mailto:help@niffomobile.com' },
      ],
      contactTitle: 'Contact',
      company: 'Niffo Mobile B.V.',
      address: 'Stationsplein 28, 1382 AD Weesp, Netherlands',
      email: 'help@niffomobile.com',
      copyright: 'Copyright © 2026 FitGainers. All rights reserved.',
    },
  },
};
